/* TerraLife — panier à deux paliers : livraison offerte (réglage du thème), puis cadeau
   mystère (réglages « Cadeau mystère »). Reprend la barre du thème (free-ship-progress-bar,
   theme.js) : le thème rappelle init() après chaque changement du panier, c'est là que la
   barre se met à jour et que le cadeau, un produit à 0 €, est ajouté (seuil atteint) ou
   retiré (en dessous). Le seuil compte les articles après réductions, hors livraison, sans
   le cadeau lui-même. */
(() => {
  const Bar = customElements.get('free-ship-progress-bar');
  if (!Bar) return;

  const money = (cents) =>
    window.Shopify && Shopify.formatMoney && window.cartStrings
      ? Shopify.formatMoney(cents, cartStrings.money_format)
      : `${(cents / 100).toFixed(2).replace('.', ',')} €`;

  Bar.prototype.init = function init(orders) {
    const order = Number(orders) || 0; // cents
    const ship = Math.round(Number(this.dataset.feAmount || 0) * 100);
    const gift = Math.round(Number(this.dataset.tlGiftAmount || 0) * 100);
    const title = this.querySelector('.free-shipping-message');
    let progress;
    let message;
    if (ship && order < ship) {
      progress = order / ship;
      message = `Plus que <strong>${money(ship - order)}</strong> pour la livraison offerte`;
      if (gift > ship) message += `<br><span class="tl-gift-next">Et un cadeau mystère 🎁 dès ${money(gift)}</span>`;
    } else if (gift && order < gift) {
      progress = ship ? (order - ship) / (gift - ship) : order / gift;
      message = `Livraison offerte ✓ · Plus que <strong>${money(gift - order)}</strong> pour ton cadeau mystère 🎁`;
    } else {
      progress = 1;
      message = gift
        ? 'Livraison offerte et cadeau mystère 🎁 : on le glisse dans ton colis !'
        : 'Livraison offerte ✓';
    }
    this.setProgressBar(Math.max(0, Math.min(1, progress)) * 100);
    if (title) {
      title.classList.remove('opacity-0');
      title.innerHTML = message;
    }
    if (gift && this.dataset.tlGiftVariant) syncGift(Number(this.dataset.tlGiftVariant), gift);
  };

  // ---------- The gift line: added at the threshold, removed below ----------
  let timer = null;
  let running = false;

  function syncGift(variantId, threshold) {
    clearTimeout(timer);
    timer = setTimeout(() => run(variantId, threshold), 250);
  }

  async function run(variantId, threshold) {
    if (running) return;
    try {
      if (sessionStorage.getItem('tl-gift-failed')) return;
    } catch (e) {}
    running = true;
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const line = cart.items.find((i) => i.variant_id === variantId);
      const others = cart.items.filter((i) => i.variant_id !== variantId);
      const subtotal = cart.items_subtotal_price - (line ? line.final_line_price : 0);
      const wanted = others.length > 0 && subtotal >= threshold;
      let body = null;
      let url = null;
      if (wanted && !line) {
        url = '/cart/add.js';
        body = { items: [{ id: variantId, quantity: 1 }] };
      } else if (!wanted && line) {
        url = '/cart/change.js';
        body = { id: line.key, quantity: 0 };
      } else if (wanted && line && line.quantity !== 1) {
        url = '/cart/change.js';
        body = { id: line.key, quantity: 1 };
      }
      if (!url) return;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...body, sections: 'minicart-form', sections_url: location.pathname }),
      });
      if (!res.ok) throw new Error(String(res.status));
      const state = await res.json();
      await refresh(state);
    } catch (e) {
      try {
        sessionStorage.setItem('tl-gift-failed', '1');
      } catch (err) {}
    } finally {
      running = false;
    }
  }

  async function refresh(state) {
    // Cart page: its lines and totals come from the page itself.
    if (document.getElementById('main-cart-items')) {
      location.reload();
      return;
    }
    const html = state.sections && state.sections['minicart-form'];
    const target = document.getElementById('minicart-form');
    if (html && target) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
      if (fresh) target.innerHTML = fresh.innerHTML;
    }
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.innerHTML = el.classList.contains('cart-count-drawer')
        ? `(${cart.item_count})`
        : cart.item_count > 100
          ? '~'
          : cart.item_count;
    });
  }

  // Bars already on the page were drawn by the theme's version: redraw them.
  document.querySelectorAll('free-ship-progress-bar').forEach((el) => el.init(el.dataset.order));
})();
